import { gql } from '@apollo/client';
const COMPONENT_COLORS = gql `
  fragment ComponentColorsFragment on ComponentNode {
    colors {
      edges {
        node {
          id
          modelSpecificationColor {
            id
            name
          }
          productVariantColor
          productVariantAssignments {
            id
            modelSpecificationSize {
              id
              sizeName {
                id
                name
              }
            }
            productVariantColor
            productVariantSize
            productVariantSnapshot {
              id
              color
              size
              productVariant {
                id
                product {
                  id
                  name
                  componentSize {
                    id
                    name
                  }
                }
                color {
                  id
                  name
                  chain
                  tape
                  slider
                }
                size {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default COMPONENT_COLORS;
